<template>
    <div>
        <rkm-form
            ref="FormFaturamento"
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="faturamento.unidadeId"
                        :validations="validations.unidade"
                        value-field="id"
                        @change="getUnidades"
                    />

                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="faturamento.infraestruturaId"
                        :validations="validations.infraestrutura"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao"
                    :requestQueryStringParams="autocompletesResquestParams.queryString"
                    :searchFields="usuarios.autocomplete.usuario"
                    text-field="cidadaoNome"
                    :validations="validations.usuario"
                    :disabled="faturamento.unidadeId && faturamento.infraestruturaId ? false : true"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="faturamento.usuario"
                />
            </rkm-col>
            <rkm-col class="flex-grow-1">
                <rkm-form-select
                    label="CBO"
                    :options="ocupacao"
                    :validations="validations.ocupacao"
                    textField="codigoNome"
                    v-model="faturamento.ocupacaoId"
                    :disabled="!faturamento.usuario"
                    valueField="id"
                    show-default-option
                />
            </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.FormFaturamento.validate(add)"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="model.faturamentos"
            ref="Table"
            sort-by="unidadeNome"
            hide-filters
        >

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(item)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import { object, error, repository } from '@/mixins'

export default {
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('transportePaciente.parametrizacao')
        }
    },
    computed: {
        autocompletesResquestParams() {

            return {
                queryString: {
                    with_not_regularized: true,
                    with_lotacoes: true,
                    infraestrutura_id: this.faturamento.infraestruturaId,
                    auxilio_alimentacao: this.model.auxilioAlimentacao ?? false
                },
            }
        },
        fields() {

            const fields = [
                {
                    key: 'unidadeNome',
                    label: 'CNES - Unidade',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'usuarioNome',
                    label: 'CNS - Profissional',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'ocupacaoCodigoNome',
                    label: 'CBO - Especialidade',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]

            return fields
        },
        usuarios() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                usuario: { required: true },
                ocupacao: { required: true },
            }
        },
        infraestruturas() {

            if (this.faturamento.unidadeId) {

                let infraestruturaPrincipal = this.form.unidades.find(u => u.id === this.faturamento.unidadeId).infraestruturas

                this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },
    },
    data: () => ({
        ocupacao: [],
        faturamento: {
            unidadeId: null,
            infraestruturaId: null,
            usuario: null,
            ocupacaoId: null
        }
    }),
    methods: {
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    const faturamento = this.clone(this.faturamento)

                    faturamento.unidadeNome = this.form.unidades
                        .find(s => s.id === faturamento.unidadeId).nomeFantasia

                    faturamento.ocupacaoCodigoNome = this.ocupacao
                        .find(s => s.id === faturamento.ocupacaoId).codigoNome

                    faturamento.infraestruturaNome = this.infraestruturas
                        .find(s => s.id === faturamento.infraestruturaId).nome

                    faturamento.usuarioNome = faturamento.usuario.cidadaoNome
                    faturamento.usuarioId = faturamento.usuario.id

                    this.model.faturamentos.push(faturamento)

                    this.resetForm()
                })
        },
        async validate() {

            const hasSetor = this.model.faturamentos
                .find(cc => cc.unidadeId === this.faturamento.unidadeId
                    && cc.infraestruturaId === this.faturamento.infraestruturaId
                    && cc.usuarioId === this.faturamento.usuario.id)

            if (hasSetor) {

                const unidadeSolicitante = this.form.unidades
                    .find(s => s.id === this.faturamento.unidadeId).nomeFantasia

                const infraestruturaNome = this.infraestruturas
                    .find(s => s.id === this.faturamento.infraestruturaId).nome

                this.showValidationNotification(`A unidade <strong>${ unidadeSolicitante }</strong>,
                    local de atendimento <strong>${ infraestruturaNome }</strong> e o(a) profissional
                    <strong>${ this.faturamento.usuario.cidadaoNome }</strong> já estão cadastrados.`)

                return false
            }

            return true
        },
        resetForm() {

            this.faturamento.unidadeId = null
            this.faturamento.infraestruturaId = null
            this.faturamento.usuario = null
            this.faturamento.ocupacaoId = null

            this.$nextTick(() => this.$refs.FormFaturamento.resetValidator())
        },
        loadLotacoes(lotacao) {

            const ocupacoesFiltradas = lotacao.filter(
                u => u.unidadeId === this.faturamento.unidadeId
                && u.infraestruturaId === this.faturamento.infraestruturaId
            );

            this.ocupacao = ocupacoesFiltradas.map(ocupacao => ocupacao.ocupacao);

            if (this.ocupacao.length === 1) {
                this.faturamento.ocupacaoId = this.ocupacao[0].id;
            }
        },
        getPrincipal(infraestruturaPrincipal) {

            const unidadePrincipal = infraestruturaPrincipal.find(u => u.principal);

            this.faturamento.infraestruturaId = unidadePrincipal ? unidadePrincipal.id : infraestruturaPrincipal[0].id;
        },
        handleDestroy(item) {

            const verificaFaturamento = this.model.bpaFaturamento.find(bpa => bpa.unidadeId == item.unidadeId)

            if(!verificaFaturamento){

                const objId = this.model.faturamentos.findIndex((obj => obj.id == item.id));

                const destroy = async () => this.model.faturamentos.splice(objId, 1)

                this.showDeleteConfirmation(`Deseja realmente excluir a unidade <strong>${ item.unidadeNome }</strong>,
                    local de atendimento <strong>${ item.infraestruturaNome }</strong>
                    e o(a) profissional <strong>${ item.usuarioNome }</strong>?`,
                    destroy)

            } else {

               this.showValidationNotification(`A unidade <strong>${ item.unidadeNome }</strong>
                    já foi faturada, não é possível excluir.`)
            }
        },
        getUnidades(){

             const verificaUnidade = this.model.faturamentos
                .find(cc => cc.unidadeId === this.faturamento.unidadeId)

                if(verificaUnidade){

                    const unidadeSolicitante = this.form.unidades
                        .find(s => s.id === this.faturamento.unidadeId).nomeFantasia

                    this.showValidationNotification(`A unidade <strong>${ unidadeSolicitante }</strong>,
                        já está parametrizada para faturamento.`)

                    this.faturamento.unidadeId = null

                    return false
                }

            return true
        }
    },
    mixins: [object, error, repository ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'faturamento.unidadeId' () {

            this.faturamento.infraestruturaId = null
        },
        'faturamento.infraestruturaId' () {

            this.faturamento.usuario = null
        },
        'faturamento.usuario' (usuario) {

            this.ocupacao = []
            this.faturamento.ocupacaoId = null

            if (usuario) {

                this.repositories.parametrizacao.lotacoes({
                    'usuario_id': usuario.id,
                    'infraestrutura_id': this.faturamento.infraestruturaId
                })
                    .then(response => {

                        this.loadLotacoes(response.data.lotacoes)
                    })
                    .catch(this.handleError)
                    .finally()
            }
        },
    }
}
</script>